import React from 'react';
import { useSelector } from 'react-redux';
import getProductItem from 'store/product/selector/getProductItem';
import getProductAttributeValue from 'utils/attributes/getProductAttributeValue';
import getProductPageSelectors from 'store/product/selector/getProductPageSelectors';
import cn from 'classnames';
import Accordion from '../../Common/Accordion/Accordion';
import styles from './ProductAttributeDescription.module.scss';

interface Props {
  selectorTypeName: string;
  sectionTitle: string;
  theme?: string;
}

const ProductAttributeDescription = ({ selectorTypeName, sectionTitle, theme }: Props) => {
  const productItem = useSelector(getProductItem);
  const productPageSelectors = useSelector(getProductPageSelectors);
  if (!productItem?.product) return null;

  const targetTypeSelector = productPageSelectors.find((selector) => selector.typeName === selectorTypeName);
  if (!targetTypeSelector) return null;
  const productAttribute = getProductAttributeValue(productItem?.product, selectorTypeName);
  const selectedOption = targetTypeSelector.options?.find((option) => option.value === productAttribute);
  if (!selectedOption) return null;

  return (
    <div className={cn(styles.productAttributeDescription, styles[`theme-${theme}`])}>
      <Accordion theme={theme} title={sectionTitle} titleClassName={styles.title}>
        <div className={styles.content}>
          <span dangerouslySetInnerHTML={{ __html: (selectedOption as any).description }} />
        </div>
      </Accordion>
    </div>
  );
};

export default ProductAttributeDescription;
